export default "__VITE_ASSET__Da8uqclr__"